/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetFatoorahPaymentState Input Action
 */
export class GetFatoorahPaymentStateInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `FATOORAHPAYMENTSTATE`;
    public getCacheObjectType = () => 'FATOORAHPAYMENTSTATE';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetFatoorahPaymentStateData {
    paymentState: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetFatoorahPaymentStateInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetFatoorahPaymentStateInput, ctx: Msdyn365.IActionContext): Promise<IGetFatoorahPaymentStateData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetFatoorahPaymentStateData[]>('/get/example/id/1', 'get');
    return { paymentState: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetFatoorahPaymentStateData>>action,
    // TODO: Give your data action a unique id
    id: 'GetFatoorahPaymentState',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
